import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Grid,
  TextField,
  Typography,
  Paper,
} from '@mui/material';

interface Props {
  city: string;
  postalCode: string;
  country: string;
  phone: string;
  professionalEmail: string;
  website: string;
  onInputChange: (field: string) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const ContactFields: React.FC<Props> = ({
  city,
  postalCode,
  country,
  phone,
  professionalEmail,
  website,
  onInputChange,
}) => {
  const { t } = useTranslation();

  return (
    <Paper elevation={0} className="glass-effect" sx={{ p: 3, borderRadius: 2 }}>
      <Typography 
        variant="h6" 
        className="animated-gradient-text" 
        gutterBottom 
        sx={{ 
          mb: 4,
          fontFamily: 'Poppins, sans-serif'
        }}
      >
        {t('registration.contactInfo')}
      </Typography>
      
      <Grid container spacing={3}>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('registration.country')}
            value={country}
            onChange={onInputChange('country')}
            required
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t('registration.city')}
            value={city}
            onChange={onInputChange('city')}
            required
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t('registration.postalCode')}
            value={postalCode}
            onChange={onInputChange('postalCode')}
            required
            variant="outlined"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('registration.phone')}
            value={phone}
            onChange={onInputChange('phone')}
            required
            variant="outlined"
            type="tel"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('registration.professionalEmail')}
            value={professionalEmail}
            onChange={onInputChange('professionalEmail')}
            required
            variant="outlined"
            type="email"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('registration.website')}
            value={website}
            onChange={onInputChange('website')}
            variant="outlined"
            type="url"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ContactFields;
